import { render, staticRenderFns } from "./PlatformGroupSelect.vue?vue&type=template&id=cac6f7f0&"
import script from "./PlatformGroupSelect.vue?vue&type=script&lang=js&"
export * from "./PlatformGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports